import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { CustomImage } from '../index';
import avatar from '@src/assets/icons/icon-account.svg';
import notification from '@src/assets/icons/icon-notification.svg';
import ProfilePopover from './ProfilePopover';
import NotificationPopover from './NotificationPopover';
import { useSelector } from 'react-redux';
import CustomSearch from '@src/components/CustomSearch';

const FastAccessText = styled.span`
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #6b7789;
`;

const ContextBase = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  white-space: nowrap;
  position: relative;
`;

const Context = styled(ContextBase)`
  height: 100px;
`;

const NumberNotify = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 16px;
  height: 16px;
  background-color: #c50e00;
  color: #fff;
  font-size: 10px;
  border-radius: 50%;
  margin: 0 20px 30px -2px;
  padding: 5px;
  position: absolute;
  right: 3px;
  top: -13px;
`;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #0f172a;
  opacity: 0.6;
  z-index: 998;
  display: ${({ isVisible }) => (isVisible ? 'block' : 'none')};
`;

const DesktopHeader = () => {
  const [isProfilePopoverVisible, setIsProfilePopoverVisible] = useState(false);
  const [isNotificationPopoverVisible, setIsNotificationPopoverVisible] = useState(false);
  const { notificationList } = useSelector((state) => state?.notifications);
  const { isAdmin } = useSelector((state) => state?.auth);
  const notificationPopoverRef = useRef(null);
  const overlayRef = useRef(null);
  const notificationIconRef = useRef(null);

  useEffect(() => {
    const handleClickAnywhere = (event) => {
      if (
        notificationPopoverRef.current &&
        !notificationPopoverRef.current.contains(event.target) &&
        !notificationIconRef.current.contains(event.target) &&
        !overlayRef.current.contains(event.target)
      ) {
        setIsNotificationPopoverVisible(false);
      }
    };

    document.addEventListener('mousedown', handleClickAnywhere);
    return () => {
      document.removeEventListener('mousedown', handleClickAnywhere);
    };
  }, []);

  return (
    <>
      <Overlay isVisible={isNotificationPopoverVisible} ref={overlayRef} />
      <Context>
        <CustomSearch />
        <ContextBase>
          {!isAdmin && (
            <>
              {/*
                <button
                  onClick={() => setIsFastAccessPopoverVisible(!isFastAccessPopoverVisible)}
                  style={{ background: 'transparent', border: 'none', marginLeft: '54px' }}
                >
                  <CustomImage src={fastAccess} style={{ padding: '0px 10px 0px 0px' }} />
                  <FastAccessText>
                    <Text t="fastAccess" />
                  </FastAccessText>
                  <FastAccessPopover
                    isFastAccessPopoverVisible={isFastAccessPopoverVisible}
                    setIsFastAccessPopoverVisible={setIsFastAccessPopoverVisible}
                  >
                    <CustomImage src={bottom} style={{ padding: '0 0 0 8px' }} />
                  </FastAccessPopover>
                </button>
              */}
              <span style={{ position: 'relative', zIndex: 999 }}>
                <NotificationPopover
                  ref={notificationPopoverRef}
                  isNotificationPopoverVisible={isNotificationPopoverVisible}
                  setIsNotificationPopoverVisible={setIsNotificationPopoverVisible}
                  notificationList={notificationList}
                  onClick={() => setIsNotificationPopoverVisible(false)}
                >
                  <CustomImage
                    ref={notificationIconRef}
                    src={notification}
                    style={{
                      cursor: 'pointer',
                      padding: '0 36px 0 24px',
                      zIndex: 1000,
                    }}
                    onClick={() => setIsNotificationPopoverVisible(!isNotificationPopoverVisible)}
                  />
                  <NumberNotify>{notificationList ? notificationList.length : 0}</NumberNotify>
                </NotificationPopover>
              </span>
            </>
          )}

          <ProfilePopover
            isProfilePopoverVisible={isProfilePopoverVisible}
            setIsProfilePopoverVisible={setIsProfilePopoverVisible}
          >
            <CustomImage
              src={avatar}
              alt="account-desktop"
              style={{ cursor: 'pointer' }}
              onClick={() => setIsProfilePopoverVisible(!isProfilePopoverVisible)}
            />
          </ProfilePopover>
        </ContextBase>
      </Context>
    </>
  );
};

export default DesktopHeader;
